import React from 'react';
import { getSpeakerImage, getSpeakerFallbackImage } from '../../lib/speakerService';

const SpeakerImage = ({ speaker, size = 'md', className = '', rounded = 'rounded-full' }) => {
  const [error, setError] = React.useState(false);
  const [loaded, setLoaded] = React.useState(false);

  const src = error ? getSpeakerFallbackImage(speaker) : getSpeakerImage(speaker) || getSpeakerFallbackImage(speaker);

  const sizeClass = {
    xs: 'w-10 h-10',
    sm: 'w-14 h-14',
    md: 'w-20 h-20',
    lg: 'w-28 h-28',
    xl: 'w-40 h-40',
    full: 'w-full h-full',
  }[size] || 'w-20 h-20';

  return (
    <div className={`${sizeClass} ${rounded} overflow-hidden bg-gray-100 dark:bg-gray-700 flex-shrink-0 ${className}`}>
      {!loaded && !error && (
        <div className="w-full h-full animate-pulse bg-gray-200 dark:bg-gray-700" />
      )}
      <img
        src={src}
        alt={speaker?.name || 'Speaker'}
        className={`w-full h-full object-cover transition-opacity duration-300 ${loaded ? 'opacity-100' : 'opacity-0'}`}
        onLoad={() => setLoaded(true)}
        onError={() => { setError(true); setLoaded(true); }}
        loading="lazy"
      />
    </div>
  );
};

export default SpeakerImage;
